import { useEffect } from "react"
import { useParams, Navigate } from "react-router-dom"
import { Users } from "lucide-react"
import { PageSpinner } from "@/components/page"
import { NoActiveTeamEmpty } from "../components/cccd/NoActiveTeamEmpty"
import { useCccdEvents } from "../hooks/useCccdEvents"
import { useBreadcrumbStore } from "../stores/breadcrumbStore"
import { TeamGallery } from "../components/cccd/TeamGallery"

function EmptyState() {
  return (
    <NoActiveTeamEmpty
      heading="Equipos"
      icon={<Users className="h-8 w-8 text-primary" />}
      description="Cuando tu equipo esté activo en el CCCD verás aquí los demás equipos que compiten."
    />
  )
}

export default function CccdCompetitorsPage() {
  const { eventId } = useParams<{ eventId?: string }>()
  const { nationalEvents, regionalEvents, isLoading } = useCccdEvents()

  const allEvents = [...nationalEvents, ...regionalEvents]
  const currentEvent = allEvents.find((e) => e.id === eventId) ?? allEvents[0] ?? null
  const setBreadcrumbLabel = useBreadcrumbStore((s) => s.setLabel)

  useEffect(() => {
    if (currentEvent) setBreadcrumbLabel(`/cccd/competidores/${currentEvent.id}`, currentEvent.name)
  }, [currentEvent, setBreadcrumbLabel])

  if (isLoading) {
    return (
      <PageSpinner />
    )
  }

  if (!currentEvent) {
    return <EmptyState />
  }

  if (eventId !== currentEvent.id) {
    return <Navigate to={`/cccd/competidores/${currentEvent.id}`} replace />
  }

  return (
    // El cambio de evento vive solo en el sidebar ("Eventos"), no dentro de esta página.
    <TeamGallery eventId={currentEvent.id} eventName={currentEvent.name} />
  )
}
